<div class="row">
  <!-- study select -->
  <div class="col-lg-4 col-md-6">
    <div class="form-floating mb-2">
      <select class="form-select" id="study" [(ngModel)]="study" [attr.disabled]="disabled() ? true: null">
        @for (study of studies(); track $index) {
          <option [ngValue]="study">
            {{study.name}}
          </option>
        }
      </select>
      <label for="study">Study Name</label>
    </div>
  </div>
  <!-- pre-defined tags -->
  @for (tag of study()!.tags; track $index) {
    <div class="col-lg-4 col-md-6">
      <div class="form-floating mb-2">
        @if (tag.type === 'text') {
          <input type="text" class="form-control" id="tag_{{tag.name}}" [(ngModel)]="tag.value"
            #textInput (change)="textInput.value=textInput.value.trim()"
            [attr.disabled]="disabled() ? true: null">
        } @else if (tag.type === 'yn' || tag.type === 'ynu') {
          <select class="form-select" id="tag_{{tag.name}}" [(ngModel)]="tag.value" [attr.disabled]="disabled() ? true: null">
            @if (tag.type === 'ynu') {
              <option [value]="'Unknown'">Unknown</option>
            }
            <option [value]="'Yes'">Yes</option>
            <option [value]="'No'">No</option>
          </select>
        }
        <label for="tag_{{tag.name}}">{{tag.displayName}}</label>
      </div>
    </div>
  }
</div>
